import { Children } from "react";
import { Grid } from "@mui/material";
import PropTypes from "prop-types";

export const GridSkeleton = ({ children, style, spacing = 2 }) => {
  // Total children count
  const count = Children.count(children);

  // Calculate xs dynamically (make them equal)
  const xs = Math.floor(12 / count);

  return (
    <Grid container spacing={spacing} style={style}>
      {Children.map(children, (child, index) => (
        <Grid item xs={xs} key={index}>
          {child}
        </Grid>
      ))}
    </Grid>
  );
};

GridSkeleton.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  spacing: PropTypes.number,
};
